import { createSelector } from "reselect";
import { macrosSuggestionsFetcher } from "./actions";

export const getMacrosSuggestions = createSelector(
  macrosSuggestionsFetcher.selector,
  ({ result }) => {
    return result?.items.map((macro) => macro.name) || [];
  }
);
